import { Context } from "../../../context.js";
import { PseudoClassSelector } from "./pseudo-class.js";
/**
 * {@link https://drafts.csswg.org/selectors/#the-focus-visible-pseudo}
 */
export class FocusVisible extends PseudoClassSelector {
    static of() {
        return new FocusVisible();
    }
    constructor() {
        super("focus-visible");
    }
    *[Symbol.iterator]() {
        yield this;
    }
    matches(element, context = Context.empty()) {
        // :focus-visible matches elements that are focused and where UA decides
        // focus should be shown. That is notably text fields and keyboard-focused
        // elements (some UA don't show focus indicator on mouse-focused elements)
        // For the purposes of accessibility testing, we currently assume that
        // we always want to look at a mode where the focus is visible. This is
        // notably due to the fact that it is a UA decision, and therefore not
        // a problem for the authors to fix if done incorrectly.
        return context.isFocused(element);
    }
}
(function (FocusVisible) {
    FocusVisible.parse = PseudoClassSelector.parseNonFunctional("focus-visible", FocusVisible.of);
})(FocusVisible || (FocusVisible = {}));
//# sourceMappingURL=focus-visible.js.map